import { memo, useEffect } from 'react';

export const LaunchScreen = memo(({ onLaunch }: { onLaunch?: () => void }) => {
  useEffect(() => {
    onLaunch?.();
  }, [onLaunch]);
  return null;
});
